import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'ql-label',
    templateUrl: './label.component.html',
    styleUrls: ['./label.component.scss']
})
export class LabelComponent implements OnInit {

    constructor() {
    }

    ngOnInit() {
    }

}
